module.exports = __webpack_public_path__ + "static/img/xlsx.5294a6f2.png";